
import React, { useState, forwardRef, useImperativeHandle } from 'react';

const SearchComponent = forwardRef(
	(
		{
			viewMode,
			toggleViewMode,
			onSearch,
			style,
			showToggleViewButton = true, // default to true
			showRefreshButton = false
		},
		ref
	) => {
		const [searchTerm, setSearchTerm] = useState('');

		useImperativeHandle(ref, () => ({
			clearSearch: () => setSearchTerm('')
		}));

		const handleSearch = () => {
			if (onSearch) {
				setSearchTerm(searchTerm);
				onSearch(searchTerm);
			}
		};

		const handleDelete = () => {
			setSearchTerm('');
			if (onSearch) {
				onSearch('');
			}
		};

		const handleRefresh = () => {
			if (onSearch) {
				onSearch(searchTerm);
			}
		};

		return (
			<div className="input-group" style={style}>
				<input
					id="searchInputTerm"
					type="text"
					className="form-control"
					placeholder="Search"
					value={searchTerm}
					onChange={e => setSearchTerm(e.target.value)}
				/>
				<button className="btn btn-secondary" type="button" onClick={handleSearch} title="Search">
					<i className="fa fa-search fixed-table-toolbar"></i>
				</button>
				<button className="btn btn-secondary" type="button" onClick={handleDelete} title="Clear">
					<i className="fa fa-trash fixed-table-toolbar"></i>
				</button>
				{showRefreshButton && (
				<button className="btn btn-secondary" type="button" onClick={handleRefresh} title="Refresh">
					<i className="fa fa-sync fixed-table-toolbar"></i>
				</button>
				)}
				{showToggleViewButton && (
					<button
						id="toggle_view_button"
						className="btn btn-secondary"
						type="button"
						title="Toggle View"
						onClick={toggleViewMode}
					>
						<i className={`fa ${viewMode === 'table' ? 'fa-toggle-off' : 'fa-toggle-on'}`}></i>
					</button>
				)}
			</div>
		);
	}
);

export default SearchComponent;
